export const routes = (prefix = `morgue`) => [
    {
        path: `/${prefix}/queue`,
        name: `${prefix}.queue.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.queue.index`,
                PageDescription: "Morgue: Queue",
            },
        },
    },
    {
        path: `/${prefix}/queue-print`,
        name: `${prefix}.queue-print.index`,
        component: () => import('./prints/InMorgue.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.queue.index`,
                PageDescription: "Morgue: Queue",
            },
        },
    },
    {
        path: `/${prefix}/interim-bill-print`,
        name: `${prefix}.interim-bill-print.index`,
        component: () => import('./prints/InterimBill.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.queue.index`,
                PageDescription: "Morgue: Queue",
            },
        },
    },
];